import * as types from "../actions/types";
import trackingInfo from "./tracking-info";

export const getHttpConfig = () => {
  return {
    headers: {
      ...trackingInfo
    }
  };
};

export const getAuthHttpConfig = storage => {
  let token = storage.authToken;
  if (token === undefined) {
    token = storage.anonymousToken;
  }

  return {
    headers: { Authorization: `Bearer ${token}`, ...trackingInfo }
  };
};

export const getAnonymousHttpConfig = storage => {
  return {
    headers: {
      Authorization: `Bearer ${storage.anonymousToken}`,
      ...trackingInfo
    }
  };
};

export const getAuthHttpConfigByToken = token => {
  return {
    headers: { Authorization: `Bearer ${token}`, ...trackingInfo }
  };
};

export const getRestaurantHttpConfig = () => {
  const authToken =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwic2NvcGUiOlsibm9tbWVBZG1pbiJdLCJlbWFpbCI6ImFkbWluQG5vbW1lLmNvbSIsIklkIjoxLCJFbWFpbCI6ImFkbWluQG5vbW1lLmNvbSIsImlhdCI6MTU0Mjg0ODI4MiwiZXhwIjoxNTc0NDA1ODgyfQ.KP4-MSrBVqXG8VggHIxTVEwJBh-WK-3xNgnrtBuN7LQ";
  return {
    headers: { Authorization: `Bearer ${authToken}` }
  };
};

export const dispatchSignOut = dispatch => {
  dispatch({ type: types.REMOVE_ITEM, payload: "authToken" });
  dispatch({ type: types.REMOVE_ITEM, payload: "anonymousToken" });
  dispatch({ type: types.REMOVE_ITEM, payload: "pushToken" });
  dispatch({ type: types.REMOVE_ITEM, payload: "customerName" });
  dispatch({ type: types.REMOVE_ITEM, payload: "favorites" });
  dispatch({ type: types.CLEAR_ORDER });
  dispatch({ type: types.CLEAR_GROUP_ORDER_INFO });
  dispatch({ type: types.SIGN_OUT_SUCCCESS });
};
